<div>
  <p>
    {{ 'user-self-service.security.delete-authorization' | transloco }} <strong>{{ deviceToRetire.customerDeviceName }}</strong>
  </p>

  <div class="row justify-content-center">
    <div class="col-12 col-md-6">
      <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
    </div>
  </div>
</div>
